import { Pipe, PipeTransform } from '@angular/core';
import { StatusKind } from '@sb/library/base';
import { StudentStatus } from '@sb/library/data-models';

@Pipe({name: 'studentStatus'})
export class StudentStatusPipe implements PipeTransform {
    transform(status: StudentStatus | string) {
        if (status === StudentStatus.Active) {
            return {
                "status": StatusKind.Success,
                "label": $localize`:@@TeacherPortalStudentsDetailsStudentStatusActive:Active`
            };
        } else if (status === StudentStatus.Lead) {
            return {
                "status": StatusKind.Lead,
                "label": $localize`:@@TeacherPortalStudentsDetailsStudentStatusLead:Lead`
            };
        } else if (status === StudentStatus.Inactive) {
            return {
                "status": StatusKind.Neutral,
                "label": $localize`:@@TeacherPortalStudentsDetailsStudentStatusInactive:Inactive`
            };
        } else if (status === StudentStatus.Trial) {
            return {
                "status": StatusKind.Trial,
                "label": $localize`:@@TeacherPortalStudentsDetailsStudentStatusTrial:Trial`
            };
        } else if (status === StudentStatus.Waiting) {
            return {
                "status": StatusKind.Waiting,
                "label": $localize`:@@TeacherPortalStudentsDetailsStudentStatusWaiting:Waiting`
            };
        } else {
            return {
                "status": StatusKind.Brand,
                "label": "-"
            };
        }
    }
}
